// Module
var code = "<div class=\"gh-modal-close-button\" ng-click=\"$close();\"><span class=\"nc-icon-outline icon ui-1_simple-remove\"></span></div><iframe style=\"width:100%;height:600px\" src=\"https://www.youtube.com/embed/3vy-xFMCqtk\" frameborder=\"0\"></iframe>";
// Exports
module.exports = code;